module.exports = __webpack_public_path__ + "img/img12.ecba4404.svg";